// Extracted from processMiner.js to enable future backend migration.
// This module keeps the same behavior but takes all state via the `ctx` object.

import { getStandardDeviation } from '@process-advisor/process-miner/processMiner/ProcessMinerUtils';

export function generateArrays(applyFilters, firstBuild, source, loadDiscoveryRules, ctx) { 
    if (firstBuild == true) {
        ctx.updateVariantMetrics();
    }
    if (applyFilters == true) {
        ctx.filterArrays();
        ctx.updateVariantMetrics();
    }
    if (loadDiscoveryRules === true) {
        ctx.updateSlicedVariables()
        return
    }
    
    ctx.gLinkArray.length = 0;


    let taskStr = ''
    let variant_id = 0;
    let variant_sequence = 0;
    let tasks = 0;
    let duration = 0;

    let worklog_ctr = 0
    let variant = '';
    let from_activity = '';
    let to_activity = '';
    let start = false;
    let end = false;
    let validRec = true;
    let loops = 0;
    let min_duration = 1000000000;
    let max_duration = 0;
    let startNode = 0;
    let endNode = 0;
    let fromNodeLabel = '';
    let toNodeLabel = '';
    let timespent = 0
    let sdArray = [];
    let actual_cost = 0;
    let forecast_cost = 0;
    sdArray.length = 0;
    for (let j = 0; j < ctx.gActivityArray.length; j++) {
        if (ctx.gActivityArray[j].start_node == true) {
            startNode = ctx.gActivityArray[j].id;
        }
        if (ctx.gActivityArray[j].end_node == true) {
            endNode = ctx.gActivityArray[j].id;
        }
    }

    ctx.gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.v - b.v || a.s - b.s);
    ctx.gVariantArray.sort((a, b) => a.id - b.id);
    // Guard: if event log is empty (e.g. custom field model with no matching history)
    // skip the entire loop to avoid "gEventLogArray[i] is undefined" crash
    if (ctx.gEventLogArray.length === 0) {
        ctx.gTasksAll = 0;
        ctx.gTasksFiltered = 0;
        return ctx;
    }
    for (let i = 0; i < ctx.gEventLogArray.length + 1; i++) {
        if (i < ctx.gEventLogArray.length && ctx.gEventLogArray[i].filtered == 1) {
            break;
        }
        if (i == 0) {
            tasks = 1;
            actual_cost = 0;
            forecast_cost = 0;
            min_duration = parseInt(ctx.gEventLogArray[i].d);
            max_duration = parseInt(ctx.gEventLogArray[i].d);
            sdArray.push(parseInt(ctx.gEventLogArray[i].d));
            duration = duration + parseInt(ctx.gEventLogArray[i].d);

            loops = 0;
            taskStr = ctx.gEventLogArray[i].tid
            if (ctx.gEventLogArray[i].loop == true) {
                loops++;
            }
        } else {
            if (
                (i < ctx.gEventLogArray.length && (ctx.gEventLogArray[i - 1].s != ctx.gEventLogArray[i].s || ctx.gEventLogArray[i - 1].v != ctx.gEventLogArray[i].v)) ||
                i == ctx.gEventLogArray.length
            ) {
                fromNodeLabel = ctx.gActivityArray[ctx.gEventLogArray[i - 1].f].activity;
                toNodeLabel = ctx.gActivityArray[ctx.gEventLogArray[i - 1].t].activity;

                start = false;
                end = false;
                if (ctx.gEventLogArray[i - 1].f == startNode) {
                    start = true;
                }
                if (ctx.gEventLogArray[i - 1].t == endNode) {
                    end = true;
                }

                let vtp = {};
                vtp['from'] = ctx.gEventLogArray[i - 1].f;
                vtp['to'] = ctx.gEventLogArray[i - 1].t;
                vtp['from_label'] = fromNodeLabel;
                vtp['to_label'] = toNodeLabel;
                vtp['variant'] = ctx.gEventLogArray[i - 1].v;
                vtp['start_node'] = start;
                vtp['end_node'] = end;
                vtp['sort_key'] = ctx.gEventLogArray[i - 1].s;
                vtp['variant_id'] = ctx.gEventLogArray[i - 1].vid;
                vtp['variant_sequence'] = ctx.gVariantArray[ctx.gEventLogArray[i - 1].vid].s;
                vtp['loops'] = loops
                if (loops > 0) {
                    vtp['loop'] = true;
                } else {
                    vtp['loop'] = false;
                }
                vtp['tasks'] = tasks;
                vtp['actual_cost'] = actual_cost;
                vtp['forecast_cost'] = forecast_cost;
                vtp['duration'] = duration;
                if (min_duration < 0) {
                    min_duration = 0;
                }
                vtp['min_duration'] = min_duration;
                vtp['max_duration'] = max_duration;
                vtp['width'] = 1;
                vtp['dashes'] = false;
                vtp['cost'] = 0;
                vtp['task_str'] = taskStr
                vtp['sd_array'] = sdArray;
                if (ctx.gEventLogArray[i - 1].duplicate === false) {
                    vtp['visible'] = true;
                    vtp['duplicate'] = false;
                } else {
                    vtp['visible'] = false;
                    vtp['duplicate'] = true;
                }
                ctx.gLinkArray.push(vtp); 

                if (i < ctx.gEventLogArray.length) {
                    tasks = 0;
                    sdArray = [];
                    sdArray.length = 0;
                    min_duration = 1000000000;
                    max_duration = 0;
                    loops = 0;
                    if (ctx.gEventLogArray[i].loop == true) {
                        loops++;
                    }
                    taskStr = ctx.gEventLogArray[i].tid
                    tasks++;
                    duration = parseInt(ctx.gEventLogArray[i].d);
                    sdArray.push(parseInt(ctx.gEventLogArray[i].d));
                    if (parseInt(ctx.gEventLogArray[i].d) < min_duration) {
                        min_duration = parseInt(ctx.gEventLogArray[i].d);
                    }
                    if (parseInt(ctx.gEventLogArray[i].d) > max_duration) {
                        max_duration = parseInt(ctx.gEventLogArray[i].d);
                    }
                    actual_cost = ctx.gEventLogArray[i].actual_cost;
                    forecast_cost = ctx.gEventLogArray[i].forecast_cost;
                }
            } else {
                tasks++;
                taskStr = taskStr + '^' + ctx.gEventLogArray[i].tid
                duration = duration + parseInt(ctx.gEventLogArray[i].d);
                sdArray.push(parseInt(ctx.gEventLogArray[i].d));
                if (parseInt(ctx.gEventLogArray[i].d) < min_duration) {
                    min_duration = parseInt(ctx.gEventLogArray[i].d);
                }
                if (parseInt(ctx.gEventLogArray[i].d) > max_duration) {
                    max_duration = parseInt(ctx.gEventLogArray[i].d);
                }
                actual_cost = ctx.gEventLogArray[i].actual_cost + actual_cost;
                forecast_cost = ctx.gEventLogArray[i].forecast_cost + forecast_cost;
                if (ctx.gEventLogArray[i].loop == true) {
                    loops++;
                }
                from_activity = ctx.gEventLogArray[i].f;
                to_activity = ctx.gEventLogArray[i].t;
                variant = ctx.gEventLogArray[i].v;
                variant_id = ctx.gEventLogArray[i].vid;
                variant_sequence = ctx.gVariantArray[ctx.gEventLogArray[i].vid].s;
            }
        }
    }

    if (validRec == true) {
        // will never be a duplicate
        for (let j = 0; j < ctx.gActivityArray.length; j++) {
            if (ctx.gActivityArray[j].id == from_activity) {
                fromNodeLabel = ctx.gActivityArray[j].activity;
                break;
            }
        }
        for (let j = 0; j < ctx.gActivityArray.length; j++) {
            if (ctx.gActivityArray[j].id == to_activity) {
                toNodeLabel = ctx.gActivityArray[j].activity;
                break;
            }
        }

        start = false;
        end = false;
        if (from_activity == startNode) start = true;
        if (to_activity == endNode) end = true;

        let vtp = {};
        vtp['from'] = from_activity;
        vtp['to'] = to_activity;
        vtp['from_label'] = fromNodeLabel;
        vtp['to_label'] = toNodeLabel;
        vtp['variant'] = variant;
        vtp['width'] = 1;
        vtp['start_node'] = start;
        vtp['end_node'] = end;
        vtp['visible'] = true;
        vtp['duplicate'] = false;
        vtp['dashes'] = false;
        vtp['tasks'] = tasks;
        vtp['actual_cost'] = actual_cost;
        vtp['forecast_cost'] = forecast_cost;
        vtp['duration'] = duration;
        vtp['min_duration'] = min_duration;
        vtp['max_duration'] = max_duration;
        vtp['sd_array'] = sdArray;
        vtp['task_str'] = taskStr
        vtp['variant_id'] = variant_id;
        vtp['variant_sequence'] = variant_sequence;
        vtp['loops'] = loops
        if (loops > 0) {
            vtp['loop'] = true;
        } else {
            vtp['loop'] = false;
        }
        ctx.gLinkArray.push(vtp);
    }
    
    // update variant array with duration metrics
    ctx.gTaskArray.sort((a, b) => a.filtered - b.filtered || a.vid - b.vid);
    ctx.gVariantArray.sort((a, b) => a.id - b.id);
    variant_id = -1;
    min_duration = 1000000000000;
    max_duration = 0;
    let total_duration = 0
    let maxTimestamp = ''
    let i = 0;
    for (i = 0; i < ctx.gTaskArray.length; i++) {
        if (ctx.gTaskArray[i].filtered == 1) {
            break;
        }
        if (i > 0 && variant_id != ctx.gTaskArray[i].vid) {
            ctx.gVariantArray[ctx.gTaskArray[i - 1].vid].min_duration = min_duration;
            ctx.gVariantArray[ctx.gTaskArray[i - 1].vid].max_duration = max_duration;
            ctx.gVariantArray[ctx.gTaskArray[i - 1].vid].max_timestamp = maxTimestamp
            ctx.gVariantArray[ctx.gTaskArray[i - 1].vid].total_duration = total_duration
            min_duration = 1000000000000;
            max_duration = 0;
            total_duration = 0
            maxTimestamp = ''
        }
        if (ctx.gTaskArray[i].d < min_duration) {
            min_duration = ctx.gTaskArray[i].d;
        }
        if (ctx.gTaskArray[i].d > max_duration) {
            max_duration = ctx.gTaskArray[i].d;
        }
        if (ctx.gTaskArray[i].t2 > maxTimestamp) {maxTimestamp = ctx.gTaskArray[i].t2}
        total_duration = ctx.gTaskArray[i].d + total_duration
        variant_id = ctx.gTaskArray[i].vid;
    }
    ctx.gVariantArray[ctx.gTaskArray[ctx.gTaskArray.length - 1].vid].min_duration = min_duration;
    ctx.gVariantArray[ctx.gTaskArray[ctx.gTaskArray.length - 1].vid].max_duration = max_duration;
    ctx.gVariantArray[ctx.gTaskArray[ctx.gTaskArray.length - 1].vid].max_timestamp = maxTimestamp  
    ctx.gVariantArray[ctx.gTaskArray[ctx.gTaskArray.length - 1].vid].total_duration = total_duration;


    // processMiner.js previously maintained a module-scoped `startTime` used for perf timing.
    // After extraction, update it via the provided setter (no-op if not provided).
    if (ctx && typeof ctx.setStartTime === 'function') {
        ctx.setStartTime(Date.now());
    }

    ctx.gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.t - b.t || a.k.localeCompare(b.k));
    ctx.gStepArray.length = 0;  // Clear in place, don't replace the array
    let events = 1;
    tasks = 0;
    taskStr = ''
    duration = 0;
    sdArray.length = 0;
    min_duration = 1000000000;
    max_duration = 0;

    end = false;
    let from = '';
    let to = '';
    let fromStr = '';
    let toStr = '';
    let sid = 0;
    maxTimestamp = ''
    actual_cost = 0;
    forecast_cost = 0;
    i = 0;
    for (i = 0; i < ctx.gEventLogArray.length; i++) {
        if (ctx.gEventLogArray[i].filtered == 1) {
            break;
        }
        if (i == 0) {
            duration = duration + parseInt(ctx.gEventLogArray[i].d);
            sdArray.push(parseInt(ctx.gEventLogArray[i].d));
            if (parseInt(ctx.gEventLogArray[i].d) < min_duration) {
                min_duration = ctx.gEventLogArray[i].d;
            }
            if (parseInt(ctx.gEventLogArray[i].d) > max_duration) {
                max_duration = ctx.gEventLogArray[i].d;
            }
            loops = 0;
            maxTimestamp = ctx.gEventLogArray[i].ts 
            from = ctx.gEventLogArray[i].f;
            to = ctx.gEventLogArray[i].t;
            actual_cost = actual_cost + ctx.gEventLogArray[i].actual_cost;
            forecast_cost = forecast_cost + ctx.gEventLogArray[i].forecast_cost;

        } else {
            if (
                ctx.gEventLogArray[i - 1].f != ctx.gEventLogArray[i].f ||
                ctx.gEventLogArray[i - 1].t != ctx.gEventLogArray[i].t ||
                ctx.gEventLogArray[i - 1].k != ctx.gEventLogArray[i].k
            ) {
                tasks++;
                if (taskStr === '') taskStr =  ctx.gEventLogArray[i-1].tid  
                else taskStr = taskStr + '^' + ctx.gEventLogArray[i-1].tid  
            }

            if (ctx.gEventLogArray[i - 1].f != ctx.gEventLogArray[i].f || ctx.gEventLogArray[i - 1].t != ctx.gEventLogArray[i].t) {
                let vtp = {};
                vtp['from'] = ctx.gEventLogArray[i - 1].f.toString();
                vtp['to'] = ctx.gEventLogArray[i - 1].t.toString();

                for (let x = 0; x < ctx.gActivityArray.length; x++) {
                    if (ctx.gActivityArray[x].id === parseInt(ctx.gEventLogArray[i - 1].f)) {
                        fromStr = ctx.gActivityArray[x].activity;
                    }
                    if (ctx.gActivityArray[x].id === parseInt(ctx.gEventLogArray[i - 1].t)) {
                        toStr = ctx.gActivityArray[x].activity;
                    }
                }
                vtp['from_label'] = fromStr
                vtp['to_label'] = toStr
                vtp['step'] = fromStr + ' -> ' + toStr

                vtp['id'] = sid 
                vtp['events'] = events;
                vtp['tasks'] = tasks;
                vtp['task_str'] = taskStr;

                vtp['duration'] = duration;
                vtp['total_duration'] = duration;
                vtp['avg_duration'] = duration / events;
                vtp['min_duration'] = min_duration;
                vtp['max_duration'] = max_duration;
                vtp['std_deviation'] = getStandardDeviation(sdArray);
                vtp['actual_cost'] = actual_cost;
                vtp['forecast_cost'] = forecast_cost;
                vtp['max_timestamp'] = maxTimestamp

                if (ctx.gEventLogArray[i - 1].filtered == 1) {
                    vtp['filtered'] = 1;
                } else {
                    vtp['filtered'] = 0;
                }
                vtp['loops'] = loops
                if (loops > 0) {
                    vtp['loop'] = true;
                } else {
                    vtp['loop'] = false;
                }
                ctx.gStepArray.push(vtp);
                sid ++

                events = 1;
                tasks = 0;
                taskStr = ctx.gEventLogArray[i].tid

                maxTimestamp = ctx.gEventLogArray[i].ts 
                sdArray.length = 0;
                sdArray.push(parseInt(ctx.gEventLogArray[i].d));
                duration = parseInt(ctx.gEventLogArray[i].d);
                min_duration = parseInt(ctx.gEventLogArray[i].d);
                max_duration = parseInt(ctx.gEventLogArray[i].d);
                actual_cost = ctx.gEventLogArray[i].actual_cost;
                forecast_cost = ctx.gEventLogArray[i].forecast_cost;
                loops = 0;
                from = ctx.gEventLogArray[i].f;
                to = ctx.gEventLogArray[i].t;
                if (ctx.gEventLogArray[i].loop == true) {
                    loops++;
                }
            } else {
                actual_cost = actual_cost + ctx.gEventLogArray[i].actual_cost;
                forecast_cost = forecast_cost + ctx.gEventLogArray[i].forecast_cost;
                events++;

                duration = duration + parseInt(ctx.gEventLogArray[i].d);
                sdArray.push(parseInt(ctx.gEventLogArray[i].d));
                if (parseInt(ctx.gEventLogArray[i].d) < min_duration) {
                    min_duration = ctx.gEventLogArray[i].d;
                }
                if (parseInt(ctx.gEventLogArray[i].d) > max_duration) {
                    max_duration = ctx.gEventLogArray[i].d;
                }
                if (ctx.gEventLogArray[i].loop == true) {
                    loops++;
                }
                if (ctx.gEventLogArray[i].ts > maxTimestamp) {maxTimestamp = ctx.gEventLogArray[i].ts}
                from = ctx.gEventLogArray[i].f;
                to = ctx.gEventLogArray[i].t;
            }
        }
    }
 
    if (i > 0) {

        let vtp = {};
        vtp['from'] = from.toString();
        vtp['to'] = to.toString();
        
        for (let x = 0; x < ctx.gActivityArray.length; x++) {
            if (ctx.gActivityArray[x].id === parseInt(from)) {
                fromStr = ctx.gActivityArray[x].activity;
            }
            if (ctx.gActivityArray[x].id === parseInt(to)) {
                toStr = ctx.gActivityArray[x].activity;
            }
        }

        vtp['from_label'] = fromStr
        vtp['to_label'] = toStr
        vtp['step'] = fromStr + ' -> ' + toStr
        vtp['id'] = sid
        vtp['loops'] = loops
        if (loops > 0) {
            vtp['loop'] = true;
        } else {
            vtp['loop'] = false;
        }
        vtp['events'] = events;
        vtp['tasks'] = tasks + 1;
        vtp['task_str'] = taskStr;

        vtp['duration'] = duration;
        vtp['total_duration'] = duration;
        vtp['avg_duration'] = duration / events;
        vtp['min_duration'] = min_duration;
        vtp['max_duration'] = max_duration;

        vtp['actual_cost'] = actual_cost;
        vtp['forecast_cost'] = forecast_cost;
        vtp['max_timestamp'] = maxTimestamp
        if (ctx.gEventLogArray[i - 1].filtered == 1) {
            vtp['filtered'] = 1;
        } else {
            vtp['filtered'] = 0;
        }
        vtp['std_deviation'] = getStandardDeviation(sdArray);
        ctx.gStepArray.push(vtp);
    }
    // update comments and worklog metrics in ctx.gStepArray and ctx.gLinkArray  (based on task_str)  

    ctx.gTaskArray.sort((a, b) => a.id - b.id);
    for (let j = 0; j < ctx.gLinkArray.length; j++) {      

        let comment_internal_ctr = 0
        let comment_customer_ctr = 0
        let worklog_ctr = 0
        let tasks_comments_internal = 0
        let tasks_comments_customer = 0
        let tasks_worklog = 0
        let time_spent = 0

        let task_str = ctx.gLinkArray[j].task_str.toString()
        let temp = task_str.split('^')    
        let tempTaskArray = [...new Set(temp)]

        for (let i = 0; i < tempTaskArray.length; i++) {
            let tasks_comments_internal_exists = false
            let tasks_comments_customer_exists = false
            let tasks_worklog_exists = false

            let comments = ctx.gTaskArray[parseInt(tempTaskArray[i])].comments
            let worklog = ctx.gTaskArray[parseInt(tempTaskArray[i])].worklog

            for (let c = 0; c < comments.length; c++) {
                if (comments[c] !== undefined) {
                    if (comments[c].jsdPublic === 'true') {
                        comment_customer_ctr ++
                        tasks_comments_customer_exists = true
                    }
                    else {
                        comment_internal_ctr ++
                        tasks_comments_internal_exists = true
                    }
                }
            }

            for (let w = 0; w < worklog.length; w++) {
                if (worklog[w] !== undefined) {
                    worklog_ctr ++
                    tasks_worklog_exists = true
                    time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                }
            }         
            if (tasks_comments_customer_exists) tasks_comments_customer ++
            if (tasks_comments_internal_exists) tasks_comments_internal ++
            if (tasks_worklog_exists) tasks_worklog ++
        }


        ctx.gLinkArray[j].comment_internal_ctr = comment_internal_ctr
        ctx.gLinkArray[j].comment_customer_ctr = comment_customer_ctr
        ctx.gLinkArray[j].worklog_ctr = worklog_ctr
        ctx.gLinkArray[j].tasks_comments_internal = tasks_comments_internal 
        ctx.gLinkArray[j].tasks_comments_customer = tasks_comments_customer 
        ctx.gLinkArray[j].tasks_worklog = tasks_worklog 
        ctx.gLinkArray[j].time_spent = time_spent

    }

    for (let j = 0; j < ctx.gStepArray.length; j++) {      

        let comment_internal_ctr = 0
        let comment_customer_ctr = 0
        let worklog_ctr = 0
        let tasks_comments_internal = 0
        let tasks_comments_customer = 0
        let tasks_worklog = 0
        let time_spent = 0
        let task_str = ctx.gStepArray[j].task_str.toString()
        let temp = task_str.split('^')    
        let tempTaskArray = [...new Set(temp)]

        for (let i = 0; i < tempTaskArray.length; i++) {
            let tasks_comments_internal_exists = false
            let tasks_comments_customer_exists = false
            let tasks_worklog_exists = false

            let comments = ctx.gTaskArray[parseInt(tempTaskArray[i])].comments
            let worklog = ctx.gTaskArray[parseInt(tempTaskArray[i])].worklog

            for (let c = 0; c < comments.length; c++) {
                if (comments[c] !== undefined) {
                    if (comments[c].jsdPublic === 'true') {
                        comment_customer_ctr ++
                        tasks_comments_customer_exists = true
                    }
                    else {
                        comment_internal_ctr ++
                        tasks_comments_internal_exists = true
                    }
                }
            }

            for (let w = 0; w < worklog.length; w++) {
                if (worklog[w] !== undefined) {
                    worklog_ctr ++
                    tasks_worklog_exists = true
                    time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                }
            }         
            if (tasks_comments_customer_exists) tasks_comments_customer ++
            if (tasks_comments_internal_exists) tasks_comments_internal ++
            if (tasks_worklog_exists) tasks_worklog ++
        }

        ctx.gStepArray[j].comment_internal_ctr = comment_internal_ctr
        ctx.gStepArray[j].comment_customer_ctr = comment_customer_ctr
        ctx.gStepArray[j].worklog_ctr = worklog_ctr
        ctx.gStepArray[j].tasks_comments_internal = tasks_comments_internal 
        ctx.gStepArray[j].tasks_comments_customer = tasks_comments_customer 
        ctx.gStepArray[j].tasks_worklog = tasks_worklog 
        ctx.gStepArray[j].time_spent = time_spent
    }

    for (let j = 0; j < ctx.gActivityArray.length; j++) {            
        ctx.gActivityArray[j].tasks = 0;
        ctx.gActivityArray[j].max_timestamp = ''
    }

    ctx.gEventLogArray = ctx.gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.t - b.t || a.k.localeCompare(b.k));
    tasks = 0;
    events = 0;
    maxTimestamp = ''
    for (i = 0; i < ctx.gEventLogArray.length; i++) {
        if (ctx.gEventLogArray[i].filtered == 1) {
            break;
        }
        if (i == 0) {
            tasks++;
            maxTimestamp = ctx.gEventLogArray[i].ts 
        } else {
            if (ctx.gEventLogArray[i - 1].t != ctx.gEventLogArray[i].t) {
                // update
                for (let j = 0; j < ctx.gActivityArray.length; j++) {            // optimize *****
                    if (ctx.gActivityArray[j].id == ctx.gEventLogArray[i - 1].t) {
                        ctx.gActivityArray[j].tasks = tasks;
                        ctx.gActivityArray[j].max_timestamp = maxTimestamp
                        break;
                    }
                }
                tasks = 0;
                maxTimestamp = ctx.gEventLogArray[i].ts 
                if (ctx.gEventLogArray[i].loop == false && ctx.gEventLogArray[i].duplicate == false) tasks++;
            } else {
                if (ctx.gEventLogArray[i].loop == false && ctx.gEventLogArray[i].duplicate == false) tasks++;
                if (ctx.gEventLogArray[i].ts > maxTimestamp) {maxTimestamp = ctx.gEventLogArray[i].ts}
            }
        }
    }
    if (i > 0) {
        for (let j = 0; j < ctx.gActivityArray.length; j++) {
            if (ctx.gActivityArray[j].id == ctx.gEventLogArray[i-1].t) {
                ctx.gActivityArray[j].tasks = tasks;
                ctx.gActivityArray[j].max_timestamp = maxTimestamp
                break;
            }
        }
    }

    for (let i = 0; i < ctx.gActivityArray.length; i++) {
        ctx.gActivityArray[i].filtered = 1;
        if (ctx.gActivityArray[i].tasks != 0 || ctx.gActivityArray[i].activity == 'Start') {
            ctx.gActivityArray[i].filtered = 0;
        }
    }
    // determine durations for activities

    ctx.gEventLogArray = ctx.gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f );
    sdArray.length = 0
    duration = 0
    events = 0
    for (i = 0; i < ctx.gEventLogArray.length; i++) {
        if (ctx.gEventLogArray[i].filtered == 1) {
            break;
        }
        if (i == 0) {
            duration = duration + parseInt(ctx.gEventLogArray[i].d);
            sdArray.push(parseInt(ctx.gEventLogArray[i].d));
            events ++
        } else {
            if (ctx.gEventLogArray[i - 1].f != ctx.gEventLogArray[i].f) {
                for (let j = 0; j < ctx.gActivityArray.length; j++) {            // optimize *****
                    if (ctx.gActivityArray[j].id == ctx.gEventLogArray[i - 1].f) {
                        ctx.gActivityArray[j].std_deviation = getStandardDeviation(sdArray);
                        ctx.gActivityArray[j].avg_duration = duration/events
                        ctx.gActivityArray[j].total_duration = duration
                        break;
                    }
                }
                sdArray.length = 0
                duration = 0
                events = 0
            } 
            duration = duration + parseInt(ctx.gEventLogArray[i].d);
            sdArray.push(parseInt(ctx.gEventLogArray[i].d));
            events ++
        }
    }
    if (i > 0) {
        for (let j = 0; j < ctx.gActivityArray.length; j++) {
            if (ctx.gActivityArray[j].id == ctx.gEventLogArray[i-1].f) {
                ctx.gActivityArray[j].std_deviation = getStandardDeviation(sdArray);
                ctx.gActivityArray[j].avg_duration = duration/events
                ctx.gActivityArray[j].total_duration = duration
            }
        }
    }

    for (let i = 0; i < ctx.gActivityArray.length; i++) {
        ctx.gActivityArray[i].filtered = 1;
        if (ctx.gActivityArray[i].tasks != 0 || ctx.gActivityArray[i].activity == 'Start') {
            ctx.gActivityArray[i].filtered = 0;
        }
    }

    // clean up
    ctx.gEventsAll = ctx.gEventLogArray.length - ctx.gTaskArray.length; // don't count end
    ctx.gTasksAll = ctx.gTaskArray.length;
    ctx.gVariantsAll = ctx.gVariantArray.length;
    ctx.gStepsAll = 0;
    ctx.gActivitiesAll = 0;
    for (let i = 0; i < ctx.gStepArray.length; i++) {
        if (ctx.gStepArray[i].to != endNode) {
            ctx.gStepsAll++;
        }
    }
    for (let i = 0; i < ctx.gActivityArray.length; i++) {
        if (ctx.gActivityArray[i].id != startNode && ctx.gActivityArray[i].id != endNode) {
            ctx.gActivitiesAll++;
        }
    }

    ctx.gEventsFiltered = 0;
    ctx.gTasksFiltered = 0;
    ctx.gVariantsFiltered = 0;
    ctx.gActivitiesFiltered = 0;
    ctx.gStepsFiltered = 0;
    for (let i = 0; i < ctx.gEventLogArray.length; i++) {
        if (ctx.gEventLogArray[i].filtered == 0 && ctx.gEventLogArray[i].t != endNode) {
            ctx.gEventsFiltered++;
        }
    }

    for (let i = 0; i < ctx.gTaskArray.length; i++) {
        if (ctx.gTaskArray[i].filtered == 0) {
            ctx.gTasksFiltered++;
        }
    }

    for (let i = 0; i < ctx.gVariantArray.length; i++) {
        if (ctx.gVariantArray[i].filtered == 0) {
            ctx.gVariantsFiltered++;
        }
    }
    for (let i = 0; i < ctx.gStepArray.length; i++) {
        if (ctx.gStepArray[i].filtered == 0 && ctx.gStepArray[i].to != endNode) {
            ctx.gStepsFiltered++;
        }
    }
    for (let i = 0; i < ctx.gActivityArray.length; i++) {
        if (ctx.gActivityArray[i].filtered == 0 && ctx.gActivityArray[i].id != startNode && ctx.gActivityArray[i].id != endNode) {
            ctx.gActivitiesFiltered++;
        }
    }

    for (let i = 0; i < ctx.gVariantArray.length; i++) {
        if (ctx.gVariantArray[i].filtered == 0) {
            ctx.gVariantArray[i].sliced = true;
        } else {
            ctx.gVariantArray[i].sliced = false;
        }
    }

    if (ctx.gProcessingModelMetrics !== true ) {
        ctx.gVariants = ctx.gVariantArray.length;
        ctx.gDiagramPVTasks = 0;
        ctx.gDiagramPVEvents = 0;
        ctx.gVariantPaneVariants = []
        ctx.gVariantArray = ctx.gVariantArray.sort((a, b) => b.t - a.t);
        if (ctx.gVariantPaneVariants.length == 0 || applyFilters == true || firstBuild == true || ctx.gDiagramPVTasks == 0) {
            let rebuildVariantPaneVariants = false
            if (ctx.gVariantPaneVariants.length == 0) {rebuildVariantPaneVariants = true}
            let selected = 0;
            for (let i = 0; i < ctx.gVariantArray.length; i++) {
                ctx.gVariantArray[i].selected = 0;
                if (ctx.gVariantArray[i].filtered == 0 ) {
                    if (selected < ctx.gDefaultVariantsSelected) {
                        ctx.gVariantArray[i].selected = 1;
                        selected++;
                        ctx.gDiagramPVTasks = ctx.gDiagramPVTasks + ctx.gVariantArray[i].t;
                        ctx.gDiagramPVEvents = ctx.gDiagramPVEvents + ctx.gVariantArray[i].e;
                        if (rebuildVariantPaneVariants === true) { 
                            const vtp = {};
                            vtp['v'] = ctx.gVariantArray[i].v;
                            vtp['n'] = ctx.gVariantArray[i].n;
                            vtp['s'] = ctx.gVariantArray[i].s;
                            vtp['id'] = ctx.gVariantArray[i].id;
                            ctx.gVariantPaneVariants.push(vtp);
                        }
                    }
                }
            }
        }
    }

    ctx.gEventLogArray = ctx.gEventLogArray.sort((a, b) => a.filtered - b.filtered)

    for (let i = 0; i < ctx.gEventLogArray.length; i++) {
        if (ctx.gEventLogArray[i].filtered === 1) break
        let stepFound = false
        for (let j = 0; j < ctx.gStepArray.length; j++) {
            if (parseInt(ctx.gEventLogArray[i].f) == parseInt(ctx.gStepArray[j].from) && parseInt(ctx.gEventLogArray[i].t) == parseInt(ctx.gStepArray[j].to)) {
                ctx.gEventLogArray[i].sid = ctx.gStepArray[j].id
                stepFound = true
            }
            if (stepFound === true) {break}
        }
        let activityFound = false
        for (let j = 0; j < ctx.gActivityArray.length; j++) {
            if (parseInt(ctx.gEventLogArray[i].f) == parseInt(ctx.gActivityArray[j].id) ) {
                ctx.gEventLogArray[i].faid = ctx.gActivityArray[j].id
                activityFound = true
            }
            if (activityFound === true) {break}
        }


    }

    // update variant activities
    ctx.gLinkArray.sort((a, b) => a.variant_id - b.variant_id || a.to_label.localeCompare(b.to_label));
    variant_id = -1
    let activities = 0
    let to_label = ''

    for (let i = 0; i < ctx.gLinkArray.length; i++) {
        if (i > 0  && ctx.gLinkArray[i].variant_id != variant_id ) {
            for (let j = 0; j < ctx.gVariantArray.length; j++) {
                if (ctx.gVariantArray[j].id === variant_id) {
                    ctx.gVariantArray[j].activities = activities - 1
                    break
                }
            }
            activities = 0
        }
        if (ctx.gLinkArray[i].to_label !== to_label) activities ++
        to_label = ctx.gLinkArray[i].to_label
        variant_id = ctx.gLinkArray[i].variant_id
    }
    for (let j = 0; j < ctx.gVariantArray.length; j++) {
        if (ctx.gVariantArray[j].id === variant_id) {
            ctx.gVariantArray[j].activities = activities - 1
            break
        }
    }

    // update variant loops
    
    let tempEventLogArray = [...ctx.gEventLogArray.sort((a, b) => a.vid - b.vid || a.k.localeCompare(b.k))]
    variant_id = -1
    let buildArray = false
    let firstTask = false
    let tempArray = []
    let task = ''

    for (let i = 0; i < tempEventLogArray.length; i++) {
        if (tempEventLogArray[i].vid !== variant_id) {
            buildArray = true
            firstTask = true
        }
        if (buildArray === true) {
            if (firstTask === false && task !== tempEventLogArray[i].k) buildArray = false
            else {
                let vtp = {};
                vtp['vid'] = tempEventLogArray[i].vid
                vtp['activity'] = tempEventLogArray[i].t
                tempArray.push(vtp)
            }
            if (firstTask === true) firstTask = false
        }
        variant_id = tempEventLogArray[i].vid
        task = tempEventLogArray[i].k

    }
    tempArray = tempArray.sort((a, b) => a.vid - b.vid || a.activity - b.activity)
    ctx.gVariantArray.sort((a, b) => a.id - b.id )
    variant_id = tempArray[0].vid
    loops = 0
    let activity = tempArray[0].activity
    i = 0
    for (i = 0; i < tempArray.length; i++) {
        if (variant_id !== tempArray[i].vid) {
            ctx.gVariantArray[tempArray[i-1].vid].loops = loops
            loops = 0
        }
        if (i > 0 && tempArray[i].activity === activity) loops ++
        variant_id = tempArray[i].vid
        activity = tempArray[i].activity
    }
    ctx.gVariantArray[tempArray[i-1].vid].loops = loops

    ctx.processVariantsTable();
    ctx.updateActivitTypeEvents()
    if (ctx.gTasksFiltered > 0) {
        ctx.updateSlicedVariables();
        ctx.updateAttributes();
        ctx.generateTaskAnalyticsArray();
        ctx.generateEventAnalyticsArray();
    }
    ctx.generateTasksFilteredArray('generateArray', false, 0, 0, 0, 0, 0); 
    ctx.gDiagramPVVariants = ctx.gVariantPaneVariants.length

    if (ctx.gEventEmitter) {
        ctx.updateFilterAttributes({ eventEmitter: ctx.gEventEmitter });
    }
    
    // Return updated counter values since primitives can't be modified by reference
    return {
        gTasksAll:          ctx.gTasksAll,
        gEventsAll:         ctx.gEventsAll,
        gVariantsAll:       ctx.gVariantsAll,
        gStepsAll:          ctx.gStepsAll,
        gActivitiesAll:     ctx.gActivitiesAll,
        gTasksFiltered:     ctx.gTasksFiltered,
        gEventsFiltered:    ctx.gEventsFiltered,
        gVariantsFiltered:  ctx.gVariantsFiltered,
        gStepsFiltered:     ctx.gStepsFiltered,
        gActivitiesFiltered: ctx.gActivitiesFiltered
    };
}